var _window = window,
    location = _window.location;
var _navigator = navigator,
    userAgent = _navigator.userAgent;
export var isExecutingInNode = function isExecutingInNode() {
  return typeof window === 'undefined';
};
export var isExecutingInBrowser = function isExecutingInBrowser() {
  return !isExecutingInNode();
};
export var isChrome = function isChrome() {
  return userAgent.match(/Chrome/);
};
export var isFirefox = function isFirefox() {
  return userAgent.match(/Firefox/);
};
export var isMSIE = function isMSIE() {
  return userAgent.match(/MSIE/);
};
export var isMSIEVersion9 = function isMSIEVersion9() {
  return userAgent.match(/MSIE\s(?=9.0)/);
};
export var getHostname = function getHostname() {
  return isExecutingInBrowser() ? location.hostname : undefined;
};
export var getOrigin = function getOrigin() {
  if (isExecutingInBrowser()) {
    var origin = location.origin,
        protocol = location.protocol,
        host = location.host;
    return !origin ? protocol + "//" + host : origin;
  }

  return undefined;
};